<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="" />
      <div class="more_txt">
        <div class="title">
          信息化产品
        </div>
        <div class="txt">
          Informatization Products
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/jk3.png" alt="" />
      </div>
      <div class="more_right">
        <div class="maxTitle">医疗健康分析平台</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            由基础的职工的病历数据、体检数据以及员工提供的个人健康数据，经过大数据清洗，修正数据错误以及将数据进行数字化处理,形成系统的可用于大数据分析的用户医疗数据。结合医疗专家基于个人健康数据以及用户的医疗数据，提出可靠的分析意见，并根据权威的医学数据，形成一套职工健康状态评估标准。实现对于原本无关联的医疗数据建立数据联系，构建一个多源融合的医疗数据仓库，进行数据挖掘，以实现建立个体、群体疾病的固有特征和数据联系，并形成全面而客观的职工健康状态的评估数据模型，实现多源数据融合。
          </div>
          <div class="title">相关案例</div>
          <div class="introimg">
             <img src="../assets/jk4.png" alt=""  />
             <div class="intro" @click="gotoDetail">
              <span class="el-icon-right"></span>
             </div>
          </div>
         
          <div class="txt last">
            医疗健康分析平台
          </div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list begin">
            <div class="title">多源基础数据组成</div>
            <div class="en">Composition of multi-source basic data</div>
            <div class="txt">
              <span class="el-icon-caret-right"></span
              >团体健康分析的数据来源多元，由最基础的体检数据为主融合了病历数据、饮食数据以及健康设备数据，得出的团检健康分析结果更加准确。
            </div>
          </div>
          <div class="more_list begin">
            <div class="title">个性化综合展示</div>
            <div class="en">Personalized comprehensive display</div>
            <div class="txt">
              <span class="el-icon-caret-right"></span
              >医疗数据可视化系统可以在有效展示数据的同时，让数据表达的内容更容易被理解，也能保证信息的有效传递，使医院的医疗信息从简单的医疗业务数据采集与储存发展到对医疗业务数据的共享和交换。
            </div>
          </div>

          <div class="more_list bottom begin">
            <div class="title">健康异常辅助分析决策</div>
            <div class="en">
              Assisted analysis and decision-making of health abnormalities
            </div>
            <div class="txt">
              <span class="el-icon-caret-right"></span
              >项目基于业务中台、数据中台、门诊(HIS)、医嘱(CPOE)、电子病历(EMR)、影像(PACS)、实验检测管理(LIS)、放射(RIS)，开展电力职工医疗数据辅助分析决策应用场景，为临床专家的治理提供分析策略管理。
            </div>
          </div>
        </div>
        <div class="more_top">
          <div class="more_list">
            <div class="title">移动端显示</div>
            <div class="en">Mobile display</div>
            <div class="txt">
              <span class="el-icon-caret-right"></span
              >据电力职工情况设置多种体检类型：如健康体检、VIP、干部体检、招工体检、招生体检、司机体检、职业体检等，各类型体检可分别采取完全不同的体检流程、检查模式，并提供不同样式的体检结果展示。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code.png" alt="" />
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from "../router/index.js";
export default {
  methods: {
    gotoHome() {
      router.push("/");
    },
    gotoDetail() {
      router.push("/detail11");
    }
  }
};
</script>
<style scoped>
.introimg{
  display: flex;
    align-items: center;
}
.intro {
  text-align: center;
  width: 75px;
  height: 35px;
  line-height: 35px;
  background: #f5a93e;
  border-radius: 4px 4px 4px 4px;
  color: #FFFFFF ;
  margin-left: 30px;
  /* margin: 0 auto; */
  }
.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;
  height: 600px;
}
.more_txt {
  position: absolute;
  top: 260px;
  right: 420px;
  color: #fff;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img {
  width: 440px;
  height: 330px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right img {
  width: 210px;
  height: 120px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 620px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;
}
.end .more_list {
  width: 280px;
  padding: 20px 10px;
  margin-top: 50px;
}
.more_detail .bottom {
  margin-right: 0;
}
.more_detail .begin {
  margin-bottom: 50px;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;
}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/MoreInfor10.vue